import { AntdFormItem } from "../AntdFormItem/AntdFormItem"
import { AntdFormItemProps, RegisterStudentCourse } from "./types"
import { Checkbox, Space, Tag } from "antd"
import { theme } from "../../styles/styles"
import React from "react"
import * as yup from "yup"
import { GiftOutlined } from "@ant-design/icons"
import { css } from "@emotion/react"

export const withGiftVoucherInitialFormValues = {
  withGiftVoucher: false
}

export const withGiftVoucherValidationSchema = {
  withGiftVoucher: yup.boolean()
}

export const WithGiftVoucherFormItem = ({
  values,
  onChange,
  errors,
  touched
}: Props<RegisterStudentCourse> & Pick<AntdFormItemProps<RegisterStudentCourse>, "errors" | "touched">) => {
  return (
    <AntdFormItem<RegisterStudentCourse>
      name="withGiftVoucher"
      label=""
      errors={errors}
      touched={touched}
      css={css`
        .ant-row {
          flex-direction: row-reverse;
        }
      `}>
      <Checkbox checked={values.withGiftVoucher} onChange={onChange}>
        Mám zájem o dárkový voucher. Nebude odeslána potvrzovací zpráva na e-mail žáka{values.student.email.length > 0 ? ` (${values.student.email})` : ""}.
      </Checkbox>
    </AntdFormItem>
  )
}

//TODO zkontrolovat zda se opravdu neposilaji mejly, mam pocit ze z administrace muze dojit k odeslani emailu zakovi i kdyz je s voucherem, ma to byt prekvapeni

interface Props<M> {
  values: M
  onChange?: (e: any) => void
}
